import { useQuery, type ApolloError } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { type APPLICATION_STATUS_TYPE } from '../../../../utils';

type GetStudentStatus = {
  status: APPLICATION_STATUS_TYPE | '';
  applicationNo: string;
  loading: boolean;
  error: ApolloError | undefined;
};

export const useGetApplicationStatus = (id: string): GetStudentStatus => {
  const { data, loading, error } = useQuery(
    gql`
      query ($id: ID!) {
        application(id: $id) {
          status
          applicationNo
        }
      }
    `,
    {
      variables: { id },
      skip: !id,
    },
  );

  const status = (data?.application?.status as APPLICATION_STATUS_TYPE) ?? '';
  const applicationNo = data?.application?.applicationNo ?? '';

  return {
    status,
    applicationNo,
    loading,
    error,
  };
};
